import { gql } from "@apollo/client";
import CollectionGroupCardFieldsFragment from "~/src/components/collection/graphql/fragments/CollectionGroupCardFieldsFragment";

export default gql`
  mutation JoinGroup($groupId: ObjectId!) {
    joinGroup(groupId: $groupId) {
      ... on PendingUser {
        _id
        primaryGroup {
          _id
        }
        groups {
          _id
          ...CollectionGroupCardFields
        }
      }
      ... on GovernmentUser {
        _id
        primaryGroup {
          _id
        }
        groups {
          _id
          ...CollectionGroupCardFields
        }
      }
      ... on VendorUser {
        _id
        primaryGroup {
          _id
        }
        groups {
          _id
          ...CollectionGroupCardFields
        }
      }
    }
  }

  ${CollectionGroupCardFieldsFragment}
`;
